module.exports = __webpack_public_path__ + "908e4d2e/img/comments-icon.fdec7fdb.svg";